// extracted by mini-css-extract-plugin
export default {"footer":"i7afNkciw_esCm8kNGgS","logo":"d630OEyizW3pK7EQ0eG3","copyright":"ICd3BR7flyD1jRpBrpRO"};